import { escapeHtml } from './fileUtils'

/**
 * 改进的Markdown渲染器
 * @param {string} markdown - Markdown内容
 * @returns {string} 渲染后的HTML
 */
export function renderMarkdown(markdown) {
    if (!markdown || typeof markdown !== 'string') {
        return '<p>暂无内容</p>'
    }

    // 首先处理代码块（防止其他规则影响代码内容）
    const codeBlocks = []
    let processedMd = markdown.replace(/```([\s\S]*?)```/g, (match, code) => {
        const index = codeBlocks.length
        codeBlocks.push(`<pre><code>${escapeHtml(code.trim())}</code></pre>`)
        return `__CODE_BLOCK_${index}__`
    })

    // 处理行内代码
    const inlineCodes = []
    processedMd = processedMd.replace(/`([^`]+)`/g, (match, code) => {
        const index = inlineCodes.length
        inlineCodes.push(`<code>${escapeHtml(code)}</code>`)
        return `__INLINE_CODE_${index}__`
    })

    // 处理表格
    processedMd = processedMd.replace(/^\|(.+)\|\s*\n\|[\s\-\|]+\|\s*\n((?:\|.+\|\s*\n?)*)/gm, (match, header, rows) => {
        const headerCells = header.split('|').map(cell => cell.trim()).filter(cell => cell)
        const rowsArray = rows.trim().split('\n').map(row =>
            row.split('|').map(cell => cell.trim()).filter(cell => cell)
        )

        let tableHtml = '<table><thead><tr>'
        headerCells.forEach(cell => {
            tableHtml += `<th>${cell}</th>`
        })
        tableHtml += '</tr></thead><tbody>'

        rowsArray.forEach(row => {
            tableHtml += '<tr>'
            row.forEach(cell => {
                tableHtml += `<td>${cell}</td>`
            })
            tableHtml += '</tr>'
        })
        tableHtml += '</tbody></table>'

        return tableHtml
    })

    // 处理标题
    processedMd = processedMd
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')

    // 处理列表
    processedMd = processedMd.replace(/^\* (.+)$/gm, '<li>$1</li>')
    processedMd = processedMd.replace(/(<li>.*<\/li>)/gs, '<ul>$1</ul>')

    processedMd = processedMd.replace(/^\d+\. (.+)$/gm, '<li>$1</li>')
    processedMd = processedMd.replace(/(<li>.*<\/li>)/gs, (match) => {
        if (match.includes('<ul>')) return match
        return `<ol>${match}</ol>`
    })

    // 处理粗体和斜体
    processedMd = processedMd
        .replace(/\*\*\*(.*?)\*\*\*/g, '<strong><em>$1</em></strong>')
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')

    // 处理链接和图片
    processedMd = processedMd
        .replace(/!\[([^\]]*)\]\(([^)]*)\)/g, '<img alt="$1" src="$2" style="max-width: 100%; height: auto;" />')
        .replace(/\[([^\]]*)\]\(([^)]*)\)/g, '<a href="$2" target="_blank">$1</a>')

    // 处理段落（双换行分段）
    processedMd = processedMd
        .split('\n\n')
        .map(paragraph => paragraph.trim())
        .filter(paragraph => paragraph.length > 0)
        .map(paragraph => {
            // 如果已经是HTML标签，不要包装p标签
            if (paragraph.match(/^<(h[1-6]|ul|ol|table|pre|div)/)) {
                return paragraph
            }
            // 处理单个换行为br
            return `<p>${paragraph.replace(/\n/g, '<br>')}</p>`
        })
        .join('\n')

    // 恢复代码块
    codeBlocks.forEach((code, index) => {
        processedMd = processedMd.replace(`__CODE_BLOCK_${index}__`, code)
    })

    // 恢复行内代码
    inlineCodes.forEach((code, index) => {
        processedMd = processedMd.replace(`__INLINE_CODE_${index}__`, code)
    })

    return processedMd
}
